import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import AdminLayout from "./pages/app/admin_layout.jsx";
import DashboardPage from "./pages/app/admin/dashboard/page.jsx";
import PropertiesPage from "./pages/app/admin/properties/page.jsx";
import PropertyId from "./pages/app/admin/properties_id/page.jsx";
import PropertyImage from "./pages/app/admin/properties/property-images/page.jsx";
import PropertySettingsPage from "./pages/app/admin/property_settings/page.tsx";
import PropertySettingId from "./pages/app/admin/property_settings/[id]/page.tsx";

// old dashboards
import DefaultersLandlord from "./pages/newDashboard/DefaultersLandlord";
import UnpaidInvoice from "./pages/newDashboard/UnpaidInvoice";
import PageAddApartment from "./pages/pages/PageAddApartment";
import SelectedHouse from './pages/newDashboard/SelectedHouse';
import Login from "./pages/auth/Login";
import Invoicing from "./pages/newDashboard/Invoicing.jsx";
import SelectedHouseImage from "./pages/newDashboard/SelectedHouseImage";
import TenantReports from './pages/newDashboard/reports/TenantReports';
import SubscriptionDashboard from "./pages/newDashboard/SubscriptionDashboard";
import Wallet from "./pages/newDashboard/Wallet";
import WalletLogin from "./pages/newDashboard/WalletLogin";
import MainWallet from "./pages/newDashboard/MainWallet";
import WalletOtp from "./pages/newDashboard/WalletOtp";
import WalletProperty from "./pages/newDashboard/WalletProperty";
import Utilities from "./pages/newDashboard/Utilities";
import Repairs from './pages/newDashboard/Repairs';
import SelectedApartmentRepairs from './pages/newDashboard/SelectedApartmentRepairs';
import Reports from './pages/newDashboard/reports/Reports';
import SelectedApartmentReport from './pages/newDashboard/reports/SelectedApartmentReport';
import RentPaymentReport from './pages/newDashboard/reports/RentPaymentReport';
import UtilitiesReport from './pages/newDashboard/reports/UtilitiesReport';
import OccupancyReport from './pages/newDashboard/reports/OccupancyReport';
import IncomeReport from './pages/newDashboard/reports/IncomeReport';
import OverflowReport from "./pages/newDashboard/reports/OverflowReport";
import FailedReconciliation from "./pages/newDashboard/reports/FailedReconciliation";
import OwnersReport from './pages/newDashboard/reports/OwnersReport';
import ApartmentIssueReport from "./pages/newDashboard/reports/ApartmentIssueReport";
import Messages from "./pages/newDashboard/Messages";
import BulkUploads from "./pages/newDashboard/BulkUploads";
import Register from "./pages/auth/Register";
import Profile from "./pages/newDashboard/Profile";
import Account from './pages/newDashboard/Account';
import ForgotPasword from "./pages/auth/ForgotPasword";
import ResetPassword from "./pages/auth/ResetPassword.jsx";
import AddTenant from "./pages/newDashboard/AddTenant";
import Home from "./pages/main/Home";
import SalesLedger from "./pages/app/admin/sales_ledger/page.jsx";
import LedgerReports from "./pages/app/admin/legder_report/page.jsx";
import PaymentApprovals from "./pages/app/admin/payment_approvals/page.jsx";
import BulkPayments from "./pages/app/admin/bulk_payments/page.jsx";
import InvoiceGenerator from "./pages/app/admin/tenant_invoicing/page.jsx";
import InvoicesUpdates from "./pages/app/admin/invoices_updates/page.jsx";
import AllInvoices from "./pages/newDashboard/AllInvoices.jsx";
import DepositReport from "./pages/app/admin/deposit_report/page.tsx";
import NewPlan from "./pages/newDashboard/NewPlan.js";
import InvoiceRecoveryPage from "./pages/app/admin/invoice_recovery/page.jsx";
import HistoricalImportPage from "./pages/app/admin/historical_import/page.jsx";

function hasValidAccessToken() {
    const storedTokens = localStorage.getItem("authTokens");

    if (!storedTokens) {
        return false;
    }

    try {
        const { access } = JSON.parse(storedTokens);
        const decodedToken = jwt_decode(access);
        const isValid = typeof decodedToken?.exp === "number"
            && decodedToken.exp > Date.now() / 1000;

        if (!isValid) {
            localStorage.removeItem("authTokens");
        }

        return isValid;
    } catch {
        localStorage.removeItem("authTokens");
        return false;
    }
}

function ProtectedRoute() {
    return hasValidAccessToken()
        ? <AdminLayout />
        : <Navigate to="/login" replace />;
}

function RootRedirect() {
    return (
        <Navigate
            to={hasValidAccessToken() ? "/dashboard" : "/login"}
            replace
        />
    );
}


export default function AdminRoutes() {
    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<RootRedirect />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/properties" element={<PropertiesPage />} />
                    <Route path="/properties/:id " element={<PropertyId />} />
                    <Route path="/selected-property-image/:id" element={<PropertyImage />} />
                    <Route path="/selected-property/:id" element={<PropertyId />} />
                    <Route path="/all-invoices/" element={<AllInvoices />} />
                    {/* property settings  */}
                    <Route path="/property-settings" element={<PropertySettingsPage />} />
                    <Route path="/property-settings/:id" element={<PropertySettingId />} />


                    <Route path="/add-apartment" element={<PageAddApartment />} />
                    <Route path='/selected-house-image/:id' element={<SelectedHouseImage />} />

                    <Route path="/invoicing/:id" element={<Invoicing />} />
                    <Route path="/defaulters-list" element={<DefaultersLandlord />} />
                    <Route path='/unpaid-invoice' element={<UnpaidInvoice />} />
                    <Route path='/tenant-report/:id' element={<TenantReports />} />
                    <Route path='/subscription' element={<SubscriptionDashboard />} />
                    <Route path='/generate-invoicing' element={<InvoiceGenerator />} />
                    <Route path='/selected-house/:id' element={<SelectedHouse />} />
                    <Route path='/wallet' element={<MainWallet />} />
                    <Route path='/property-wallet/:id' element={<Wallet />} />
                    <Route path='/wallet-property/:id' element={<WalletProperty />} />
                    <Route path="/utilities" element={<Utilities />} />
                    <Route path="/expense" element={<Repairs />} />
                    <Route path="/selected-apartment-repairs/:id" element={<SelectedApartmentRepairs />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path='/selected-property-report/:id' element={<SelectedApartmentReport />} />

                    {/* routes */}
                    <Route path='/occupancy-report/:id' element={<OccupancyReport />} />
                    <Route path='/income-report/:id' element={<IncomeReport />} />
                    <Route path='/payment-report/:id' element={<RentPaymentReport />} />
                    <Route path='/utility-report/:id' element={<UtilitiesReport />} />
                    <Route path='/failed-report/:id' element={<FailedReconciliation />} />
                    <Route path='/overpayment-report/:id' element={<OverflowReport />} />
                    <Route path='/owner-report/:id' element={<OwnersReport />} />
                    <Route path='/tenants-feedback/:id' element={<ApartmentIssueReport />} />
                    <Route path='/payments-updates/:id' element={<BulkPayments />} />
                    <Route path='/payments-updates' element={<BulkPayments />} />
                    <Route path="/messages" element={<Messages />} />
                    <Route path="/bulk" element={<BulkUploads />} />
                    <Route path='/account/:id' element={<Account />} />
                    <Route path="add-tenant/:id/:housetenant" element={<AddTenant />} />
                    <Route path="/category-c" element={<SalesLedger/>} />
                    <Route path="/ledger-reports" element={<LedgerReports />} />
                    <Route path="/payment-approvals" element={<PaymentApprovals />} />
                    <Route path="/invoice-updates/:id" element={<InvoicesUpdates />} />
                    <Route path="/deposit-report/:id" element={<DepositReport />} />
                    <Route path="/new-plan/:id" element={<NewPlan />} />
                    <Route path="/invoice-recovery" element={<InvoiceRecoveryPage />} />
                    <Route path="/invoice_recovery" element={<InvoiceRecoveryPage />} />
                    <Route path="/historical-import" element={<HistoricalImportPage />} />


                    <Route path="/profile" element={<Profile />} />

                </Route>
                <Route path="/login" element={<Login />} />
                <Route path='/wallet-otp' element={<WalletOtp />} />
                <Route path='/wallet-login' element={<WalletLogin />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPasword />} />
                <Route path="/landing-page" element={<Home />} />

                <Route path='/reset-password' element={<ResetPassword />} />

                <Route path="*" element={<RootRedirect />} />

            </Routes>
        </HashRouter>
    );
}
